import { useSelector } from 'react-redux'
import React from 'react'
import CTAButton from 'src/components/common/CTAButtonNew'
import Image from 'src/components/common/Image'
import CompareContainer from 'src/components/template/compare/components/modules/Container'
import { breakpointQuery } from 'src/components/template/compare/constants/breakpoint'
import { heading } from 'src/components/template/compare/constants/typography'
import { fireUIInteractionEvent } from 'src/modules/analytics/v3'
import { selectStateForProtobuf } from 'src/modules/reducers'
import styled from 'styled-components'
import { useCtaText } from 'src/modules/hooks/useCtaText'
import HeroFootNote from 'src/components/common/HeroSectionNew/components/HeroFootNote'

const CompareHeroSection = ({ lang, market, competitor, data }) => {
  const { title, subtitle } = data
  const background = 'https://assets-imgx.fubo.tv/marketing/lp/images/compare/compare_hero_2.jpg'
  const stateForProtobuf = useSelector(selectStateForProtobuf)
  const ctaCopy = useCtaText({ lang, market })

  // Click Tracking
  const handleOnClick = () => {
    fireUIInteractionEvent(
      {
        element: ctaCopy,
        component: 'hero_section_cta_clicked',
        type: 'clicked',
      },
      stateForProtobuf
    )
  }
  return (
    <StyledCompareHeroSection className="compare-hero">
      <div className="background">
        <Image src={background} />
      </div>
      <CompareContainer className="content">
        <h1>
          <span className="fubo-logo">Fubo</span>
          <span className="vs"> vs </span>
          <span className="competitor-logo">{competitor}</span>
        </h1>
        <div className="text">
          <h2>{title}</h2>
          <h3>{subtitle}</h3>
          <CTAButton
            link="https://www.fubo.tv/signup?comp=hero"
            style={{ marginTop: '20px' }}
            onClick={handleOnClick}
          >
            {ctaCopy}
          </CTAButton>
          <HeroFootNote lang={lang} market={market} showEspn={true} />
        </div>
      </CompareContainer>
    </StyledCompareHeroSection>
  )
}

export default CompareHeroSection

const StyledCompareHeroSection = styled.section`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 330px;
  padding-top: 40px;
  padding-bottom: 40px;

  ${breakpointQuery.desktop} {
    min-height: 580px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background:
        linear-gradient(0deg, #000f26 0%, rgba(0, 15, 38, 0.2) 50%, rgba(0, 15, 38, 0) 100%),
        radial-gradient(66.81% 130% at 50% 50%, rgba(0, 15, 38, 0) 0%, rgba(0, 15, 38, 0.8) 100%),
        rgba(0, 15, 38, 0.6);
    }
  }
  .content {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 33px 30px;
    margin: 0px auto;

    @media (max-width: 480px) {
      max-width: 250px;
    }
    ${breakpointQuery.mobile} {
      max-width: 500px;
    }
    ${breakpointQuery.desktop} {
      flex-direction: row-reverse;
      gap: 50px;
      ${'' /* max-width: 1480px; */}
    }

    h1 {
      flex: 1;
      display: flex;
      gap: 10px;
      justify-content: center;
      align-items: center;

      font-style: normal;
      font-weight: 800;
      font-size: 36px;
      line-height: 1;
      color: #ffffff;
      white-space: nowrap;
      /* identical to box height, or 166% */

      ${breakpointQuery.desktop} {
        font-size: 50px;
        gap: 20px;
      }

      @media (min-width: 1000px) {
        font-size: 66px;
      }

      .fubo-logo {
      }
      .vs {
        font-style: normal;
        font-weight: 500;
        font-size: 10.2222px;
        line-height: 21px;
        /* identical to box height, or 209% */
        color: #ffffff;
        ${'' /* position: absolute; */}

        ${breakpointQuery.desktop} {
          font-size: 18.7407px;
          line-height: 39px;
        }
      }
      .competitor-logo {
      }
    }
    .text {
      text-align: center;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 20px;

      ${breakpointQuery.desktop} {
        text-align: left;
        align-items: flex-start;
      }

      h2 {
        ${heading.lg}
        text-shadow: 0px 0px 40px #000f26;
        color: #ffffff;
        ${breakpointQuery.desktop} {
          ${heading.xxl}
        }
      }
      h3 {
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 22px;
        /* or 147% */

        text-align: center;

        /* Grey / Grey-400 */

        color: #e5e6e6;

        ${breakpointQuery.desktop} {
          text-align: left;
          ${heading.md}
        }
      }
    }
  }
`
